import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-login-sms.magic.css.js';
import script from './keycloak-login-sms.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{ref:"form",staticStyle:{"display":"none"},attrs:{"action":_vm.loginAction,"method":"post"}},[_c('input',{attrs:{"id":"code","name":"code","autocomplete":"off"}}),_vm._v(" "),_c('input',{attrs:{"id":"resendButton","name":"resendButton","autocomplete":"off"}})]),_vm._v(" "),_c('magic-ui-text',{staticClass:"message",attrs:{"content":_vm.$t('login-sms.message')}}),_vm._v(" "),(_vm.formConfig)?_c('magic-form-builder',{domProps:{"config":_vm.formConfig},on:{"form-submit":function($event){return _vm.submit($event.detail[0])}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"resend"},[_c('magic-ui-text',{staticClass:"resend-message",attrs:{"content":_vm.resendMessage}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"resend-button",attrs:{"hollow":"","variant":"primary","small":"","no-margin":"","disabled":_vm.resendDisabled},domProps:{"innerHTML":_vm._s(_vm.$t('login-sms.resend-button'))},on:{"click":_vm.resend}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-340ebc8b_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-340ebc8b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
